export default "__VITE_ASSET__CzCFY$nN__"